// This file configures the initialization of Sentry and PostHog on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
// https://posthog.com/docs/libraries/next-js

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/project/:id\",\"regex\":\"^/project/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:id/checklists/:checklistId\",\"regex\":\"^/project/([^/]+)/checklists/([^/]+)$\",\"paramNames\":[\"id\",\"checklistId\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:id/edit-description\",\"regex\":\"^/project/([^/]+)/edit-description$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:id/manage-members\",\"regex\":\"^/project/([^/]+)/manage-members$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:id/todos/:todoId\",\"regex\":\"^/project/([^/]+)/todos/([^/]+)$\",\"paramNames\":[\"id\",\"todoId\"],\"hasOptionalPrefix\":false},{\"path\":\"/tools/:id\",\"regex\":\"^/tools/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/boverksnytt/:weekIdentifier\",\"regex\":\"^/boverksnytt/([^/]+)$\",\"paramNames\":[\"weekIdentifier\"],\"hasOptionalPrefix\":false},{\"path\":\"/canvas/share/:token\",\"regex\":\"^/canvas/share/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/canvas/:id\",\"regex\":\"^/canvas/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/chat/:id\",\"regex\":\"^/chat/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/lists/:listId\",\"regex\":\"^/lists/([^/]+)$\",\"paramNames\":[\"listId\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id\",\"regex\":\"^/projects/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/edit\",\"regex\":\"^/projects/([^/]+)/edit$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/lists/:listId\",\"regex\":\"^/projects/([^/]+)/lists/([^/]+)$\",\"paramNames\":[\"id\",\"listId\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/members\",\"regex\":\"^/projects/([^/]+)/members$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/regulations\",\"regex\":\"^/projects/([^/]+)/regulations$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/rendering/share/:id\",\"regex\":\"^/rendering/share/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/updates/:slug\",\"regex\":\"^/updates/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/updates/boverksnytt/:weekIdentifier\",\"regex\":\"^/updates/boverksnytt/([^/]+)$\",\"paramNames\":[\"weekIdentifier\"],\"hasOptionalPrefix\":false},{\"path\":\"/workflows/:id\",\"regex\":\"^/workflows/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/checklist-templates/:bucketId\",\"regex\":\"^/admin/checklist-templates/([^/]+)$\",\"paramNames\":[\"bucketId\"],\"hasOptionalPrefix\":false},{\"path\":\"/auth/invitation/:token\",\"regex\":\"^/auth/invitation/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/dev/ui-overhaul/canvas/:id\",\"regex\":\"^/dev/ui-overhaul/canvas/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/dev/ui-overhaul/lists/:listId\",\"regex\":\"^/dev/ui-overhaul/lists/([^/]+)$\",\"paramNames\":[\"listId\"],\"hasOptionalPrefix\":false},{\"path\":\"/dev/ui-port-review-preview/:state\",\"regex\":\"^/dev/ui-port-review-preview/([^/]+)$\",\"paramNames\":[\"state\"],\"hasOptionalPrefix\":false},{\"path\":\"/join/:orgSlug/:token\",\"regex\":\"^/join/([^/]+)/([^/]+)$\",\"paramNames\":[\"orgSlug\",\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/superadmin/billing/:organizationId\",\"regex\":\"^/superadmin/billing/([^/]+)$\",\"paramNames\":[\"organizationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/superadmin/communication/contacts/:id\",\"regex\":\"^/superadmin/communication/contacts/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/reset-password\"},{\"path\":\"/signup\"},{\"path\":\"/signup/checkout\"},{\"path\":\"/signup/enterprise\"},{\"path\":\"/verify-email\"},{\"path\":\"/workspace-access\"},{\"path\":\"/documents\"},{\"path\":\"/project/new\"},{\"path\":\"/review\"},{\"path\":\"/tools\"},{\"path\":\"/tools/new\"},{\"path\":\"/boverksnytt\"},{\"path\":\"/boverksnytt-public\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/terms-of-service\"},{\"path\":\"/whats-new\"},{\"path\":\"/\"},{\"path\":\"/canvas\"},{\"path\":\"/dev/workflow-cards\"},{\"path\":\"/dev/workflow-composer\"},{\"path\":\"/dev/workflow-lifecycle\"},{\"path\":\"/dev/workflow-runs\"},{\"path\":\"/dev/workflow-test-loop\"},{\"path\":\"/feedback\"},{\"path\":\"/home\"},{\"path\":\"/library\"},{\"path\":\"/lists\"},{\"path\":\"/lists/archive\"},{\"path\":\"/projects\"},{\"path\":\"/projects/new\"},{\"path\":\"/rendering\"},{\"path\":\"/updates\"},{\"path\":\"/updates/boverksnytt\"},{\"path\":\"/workflows\"},{\"path\":\"/admin\"},{\"path\":\"/admin/branding\"},{\"path\":\"/admin/checklist-templates\"},{\"path\":\"/admin/documents\"},{\"path\":\"/admin/invitations\"},{\"path\":\"/admin/members\"},{\"path\":\"/admin/usage\"},{\"path\":\"/dev/archicad-bridge\"},{\"path\":\"/dev/attachment-ui-lab\"},{\"path\":\"/dev/checklist-ui-lab\"},{\"path\":\"/dev/checklist-ui-lab/legacy\"},{\"path\":\"/dev/checklist-ui-lab/new\"},{\"path\":\"/dev/generation-effect-lab\"},{\"path\":\"/dev/plan-card-resilience\"},{\"path\":\"/dev/plan-mode\"},{\"path\":\"/dev/plugin-update-banner-lab\"},{\"path\":\"/dev/project-regulations-comparison\"},{\"path\":\"/dev/regulation-selector-lab\"},{\"path\":\"/dev/revit-navigation-selector-lab\"},{\"path\":\"/dev/revit-plan-mode\"},{\"path\":\"/dev/ui-overhaul\"},{\"path\":\"/dev/ui-overhaul/canvas\"},{\"path\":\"/dev/ui-overhaul/library\"},{\"path\":\"/dev/ui-overhaul/lists\"},{\"path\":\"/dev/ui-overhaul/projects\"},{\"path\":\"/dev/ui-overhaul/settings\"},{\"path\":\"/dev/ui-port-review\"},{\"path\":\"/dev/ui-port-review-preview/checklist-template\"},{\"path\":\"/dev/workflow-examples-lab\"},{\"path\":\"/dev/workflow-examples-lab/preview\"},{\"path\":\"/downloads\"},{\"path\":\"/regulations/open\"},{\"path\":\"/settings\"},{\"path\":\"/superadmin\"},{\"path\":\"/superadmin/assistant-skills\"},{\"path\":\"/superadmin/backfill\"},{\"path\":\"/superadmin/boverket\"},{\"path\":\"/superadmin/checklist-templates\"},{\"path\":\"/superadmin/communication\"},{\"path\":\"/superadmin/communication/contacts\"},{\"path\":\"/superadmin/communication/delivery-log\"},{\"path\":\"/superadmin/communication/projects\"},{\"path\":\"/superadmin/communication/settings\"},{\"path\":\"/superadmin/communication/transactional\"},{\"path\":\"/superadmin/documents/global\"},{\"path\":\"/superadmin/enterprise-passes\"},{\"path\":\"/superadmin/invitations\"},{\"path\":\"/superadmin/organizations\"},{\"path\":\"/superadmin/regulatory-collections\"},{\"path\":\"/superadmin/updates\"},{\"path\":\"/superadmin/votes\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.7";import * as Sentry from '@sentry/nextjs';
import type { BeforeSendFn } from 'posthog-js';
import posthog from 'posthog-js';
import { getClientAnalyticsPlatform } from './lib/analytics/platform';
import { redactPostHogExceptionEvent } from './lib/analytics/posthog-errors';
import { getSentryClientEnvironment, SENTRY_DSN } from './lib/sentry/env';

const { isDevelopment, environment, shouldInitialize } =
  getSentryClientEnvironment();

// Diagnostic logging (client-side) - only in development
if (typeof window !== 'undefined' && isDevelopment) {
  console.log(
    '[SENTRY CLIENT] Environment:',
    environment,
    '| Initialize:',
    shouldInitialize,
  );
}

if (shouldInitialize) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/app\.arkyv\.ai/,
      /^https:\/\/.*\.vercel\.app/,
    ],
    tracesSampleRate: 1.0,
    enableLogs: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
  });
} else if (typeof window !== 'undefined' && isDevelopment) {
  console.log('[SENTRY CLIENT] Skipping - not production');
}

// ============================================================================
// PostHog Analytics
// ============================================================================

import { env } from './config/env';

const posthogKey = env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com';
const appEnv = env.NEXT_PUBLIC_APP_ENV || 'local';

// Track initialization state for components to check
let posthogInitialized = false;

// One-time callbacks to run when PostHog finishes loading. Lets deferred
// producers (e.g. plugin updater-status capture) stash work and flush it once
// analytics is ready, instead of busy-polling `isPostHogInitialized()`.
const posthogReadyCallbacks: Array<() => void> = [];

/**
 * Runs `callback` once PostHog is ready to send events. Fires synchronously if
 * PostHog is already initialized. If PostHog is never configured (no key), the
 * callback is never invoked, which is correct: there is nothing to send.
 */
export function onPostHogReady(callback: () => void): void {
  if (posthogInitialized) {
    callback();
    return;
  }

  posthogReadyCallbacks.push(callback);
}

const beforeSendPostHogEvent: BeforeSendFn = (event) =>
  redactPostHogExceptionEvent(event, {
    environment: appEnv,
    platform: getClientAnalyticsPlatform(),
  });

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    // Use modern defaults for pageview/pageleave tracking and error capture.
    defaults: '2026-01-30',
    // Enable session recording
    disable_session_recording: false,
    // Respect Do Not Track browser setting
    respect_dnt: true,
    // Mask all text in session recordings for privacy
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
    // Capture browser runtime failures explicitly while keeping console.error
    // capture disabled until volume and privacy impact are reviewed.
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
    error_tracking: {
      captureExtensionExceptions: false,
      exception_steps: {
        enabled: false,
      },
    },
    before_send: beforeSendPostHogEvent,
    // Debug mode in development
    loaded: (ph) => {
      const platform = getClientAnalyticsPlatform();

      // Register super properties - attached to ALL events
      ph.register({ environment: appEnv, platform });
      posthogInitialized = true;

      // Flush any work deferred until analytics was ready.
      for (const callback of posthogReadyCallbacks.splice(0)) {
        try {
          callback();
        } catch {
          // A misbehaving ready-callback must not break PostHog init.
        }
      }

      if (isDevelopment) {
        ph.debug();
        console.log('[POSTHOG] Initialized in debug mode');
      }
    },
  });
} else if (typeof window !== 'undefined' && isDevelopment) {
  console.log('[POSTHOG] Skipping - no API key configured');
}

/**
 * Check if PostHog has been initialized.
 * Use this before calling PostHog methods to prevent errors.
 */
export function isPostHogInitialized(): boolean {
  return posthogInitialized;
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
